type FunnelLoadingStateProps = {
  label: string;
  detail?: string;
  showMark?: boolean;
};

export const FunnelLoadingState = ({
  label,
  detail = "A quiet moment while everything falls into place.",
  showMark = true
}: FunnelLoadingStateProps) => (
  <section
    className={`step funnel-loading-state ${showMark ? "funnel-loading-state-with-mark" : "funnel-loading-state-with-path"}`}
    aria-busy="true"
    aria-live="polite"
  >
    <div className="funnel-loading-ambient" aria-hidden="true">
      <span className="funnel-loading-ambient-ring funnel-loading-ambient-ring-outer" />
      <span className="funnel-loading-ambient-ring funnel-loading-ambient-ring-inner" />
    </div>

    {showMark ? (
      <div className="funnel-loading-mark" aria-hidden="true">
        <span className="funnel-loading-mark-halo" />
        <span className="funnel-loading-gurmukhi">ਸ</span>
      </div>
    ) : (
      <div className="funnel-loading-path" aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
    )}

    <div className="funnel-loading-copy">
      <p className="funnel-loading-eyebrow">Sehaj · ਸਹਜ</p>
      <h1>{label}</h1>
      <p>{detail}</p>
    </div>

    <div
      className="funnel-loading-progress"
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <span />
    </div>

    <p className="funnel-loading-trust">Private by default · your path stays yours</p>
  </section>
);
